import React from "react";
import "./Footer.css";

import { FaFacebookF, FaInstagram, FaChevronRight, FaYoutube } from "react-icons/fa";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaPaperPlane } from "react-icons/fa";

import { useLanguage } from '../../contexts/LanguageContext';

function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="footer">

      <div className="footer-content">

        {/* ABOUT SECTION */}
        <div className="footer-section about">
          <img
            src="YOGA KAREGA INDIA (7).png"
            alt="YOGA KAREGA INDIA"
            className="footer-logo"
          />

          <div className="footer-about">
            <p className="iso-certified-text">
              <strong>Yoga Karega India – A branch of Yoga at Your Home | ISO Certified</strong>
            </p>
            <p>
              {t('footer.about.desc')}
              <br />
              {t('footer.about.tagline')}
            </p>

            <div className="social-links">
              <a href="https://facebook.com/bsfoodequipment_" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>

              <a href="https://instagram.com/bsfoodequipment_" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>

              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section links">
          <h3 className="footer-heading">{t('footer.links.title')}</h3>

          <ul className="footer-links">
            <li><a href="/Home"><FaChevronRight /> {t('nav.home')}</a></li>
            <li><a href="/Booking"><FaChevronRight /> {t('footer.links.booking')} </a></li>
            <li><a href="/Gallery"><FaChevronRight /> {t('footer.links.gallery')} </a></li>
            <li><a href="/about"><FaChevronRight /> {t('nav.about')} </a></li>
          </ul>
        </div>

        {/* CONTACT SECTION */}
        <div className="footer-section contact">
          <h3 className="footer-heading">{t('footer.contact.title')}</h3>




          <div className="contact-item">
            <div className="contact-icon">
              <FaPhoneAlt />
            </div>
            <div className="contact-text">
              <h4>{t('footer.contact.phone_title')}</h4>
              <p><a href="tel:+919370832534">+91 9370832534</a></p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <FaEnvelope />
            </div>
            <div className="contact-text">
              <h4>{t('footer.contact.email_title')}</h4>
              <p><a href="mailto:yogakaregaindia@gmail.com">yogakaregaindia@gmail.com</a></p>
            </div>
          </div>


        </div>

        {/* NEWSLETTER */}
        <div className="footer-section newsletter">
          <h3 className="footer-heading">{t('footer.newsletter.title')}</h3>

          <p>{t('footer.newsletter.desc')}</p>
          <br />
          <form className="newsletter-form">
            <input type="email" className="newsletter-input" placeholder={t('footer.newsletter.placeholder')} required />
            <button type="submit" className="newsletter-btn">
              <FaPaperPlane />
            </button>
          </form>
          <br></br>
          <div className="payment-methods">
            <div className="footer-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d284.20790774536133!2d77.9647495!3d27.2067513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjfCsDEyJzI0LjMiTiA3N8KwNTcnNTMuMSJF!5e0!3m2!1sen!2sin!4v1702455900000!5m2!1sen!2sin"
                width="100%"
                height="200"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
                title="Yoga Studio Location Map"
              ></iframe>
            </div>

          </div>
        </div>

      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        <p className="copyright">
          © {new Date().getFullYear()} Yoga Karega India. {t('footer.copyright')}
        </p>
      </div>

    </footer>
  );
}

export default Footer;
